export default "__VITE_ASSET__DKPWySUs__"